import ResizeObserver from "resize-observer-polyfill";

if (!("ResizeObserver" in window)) {
  if (window != null) (window as any).ResizeObserver = ResizeObserver;
}
